import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const articleImages: Record<string, string> = {
  'jia-ju-fengshui-rumen': 'https://readdy.ai/api/search-image?query=Bright%20modern%20Chinese%20living%20room%20with%20Feng%20Shui%20elements%2C%20lucky%20bamboo%20plant%2C%20warm%20sunlight%20through%20windows%2C%20harmonious%20minimal%20decor%2C%20cream%20walls%2C%20wooden%20furniture%2C%20editorial%20interior%20photography%2C%20high%20detail&width=400&height=300&seq=article-jia-ju-fengshui-rumen&orientation=landscape',
  'caiwei-xuanzhi-jueqiao': 'https://readdy.ai/api/search-image?query=Chinese%20living%20room%20corner%20with%20money%20tree%20plant%20and%20golden%20decorations%2C%20warm%20soft%20lighting%2C%20elegant%20minimal%20style%2C%20cream%20walls%2C%20editorial%20photography%2C%20high%20detail&width=400&height=300&seq=article-caiwei-xuanzhi-jueqiao&orientation=landscape',
  'shuijing-nengliang-zhinan': 'https://readdy.ai/api/search-image?query=Beautiful%20collection%20of%20natural%20crystals%20including%20citrine%20amethyst%20rose%20quartz%20on%20silk%20fabric%2C%20soft%20warm%20lighting%2C%20minimal%20luxurious%20composition%2C%20cream%20background%2C%20editorial%20photography%2C%20high%20detail&width=400&height=300&seq=article-shuijing-nengliang-zhinan&orientation=landscape',
  'keting-buju-jueqiao': 'https://readdy.ai/api/search-image?query=Bright%20modern%20Chinese%20style%20living%20room%20with%20lucky%20elements%2C%20sofa%20against%20wall%2C%20money%20tree%20plant%2C%20warm%20sunlight%2C%20cream%20walls%2C%20harmonious%20minimal%20decor%2C%20editorial%20interior&width=400&height=300&seq=article-keting-buju-jueqiao&orientation=landscape',
};

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 4);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat?.name || slug;
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选开运文章
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            由资深风水命理专家撰写的深度好文，助您全方位提升运势
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col sm:flex-row bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full sm:w-48 h-48 sm:h-auto flex-shrink-0">
                <img
                  src={articleImages[article.slug] || `https://readdy.ai/api/search-image?query=Traditional%20Chinese%20auspicious%20elements%20on%20cream%20background%2C%20minimal%20style&width=400&height=300&seq=article-fallback&orientation=landscape`}
                  alt={article.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-between">
                <div>
                  <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-2">
                    {getCategoryName(article.category)}
                  </span>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {article.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/fengshui"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-background-50 border border-background-200 text-foreground-700 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}